// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ExportReportWrapper__wrapper","cardHeader":"ExportReportWrapper__cardHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExportReportWrapper/ExportReportWrapper.scss
// module id = ./src/components/ExportReportWrapper/ExportReportWrapper.scss
// module chunks = 2